import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { TipCard } from 'src/modules/programs/components/TipCard';
import * as S from 'src/modules/programs/stepComponents/styles';
import judgmentsOurselvesIcon from 'src/public/img/illustration-emotional-distress.svg';
import judgmentsEmotionIcon from 'src/public/img/undraw-before-dawn-bqrj.svg';

const emotionsIcons = [judgmentsOurselvesIcon, judgmentsEmotionIcon];

interface JudgmentsType {
    title: string;
    description: string;
    icon: string;
}

export const JudgmentsStep = withTranslation('cbt')(({ t }: WithTranslation) => {
    const judgmentsTypes: JudgmentsType[] = t('week-4.judgments.judgmentsTypes', {
        returnObjects: true,
    });

    return (
        <>
            <S.ContentRow>
                <S.ContentColumn>
                    <S.StepHeading>{t('week-4.judgments.title')}</S.StepHeading>
                    <S.StepDescription small>{t('week-4.judgments.description')}</S.StepDescription>
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow type="flex">
                {judgmentsTypes
                    .map((judgment: JudgmentsType, index: number) => ({
                        ...judgment,
                        icon: emotionsIcons[index],
                    }))
                    .map((judgmentType: JudgmentsType) => (
                        <TipCard
                            iswide
                            key={judgmentType.title}
                            iconUrl={judgmentType.icon}
                            title={judgmentType.title}
                            children={judgmentType.description}
                        />
                    ))}
            </S.ContentRow>
        </>
    );
});
